export const ANALYTICS_DEV_EVENT = 'evisort:analytics-dev-event';

export type AnalyticsDevEventType = 'api-call' | 'click' | 'hover' | 'track';

export type AnalyticsDevEvent = {
  attributes: Record<string, unknown>;
  eventName: string;
  eventType: AnalyticsDevEventType;
  timestamp: number;
};

export function publishAnalyticsDevEvent(event: AnalyticsDevEvent) {
  if (
    process.env.NODE_ENV === 'production' ||
    typeof globalThis.dispatchEvent !== 'function'
  ) {
    return;
  }

  globalThis.dispatchEvent(
    new CustomEvent<AnalyticsDevEvent>(ANALYTICS_DEV_EVENT, { detail: event }),
  );
}
